import { styled } from '@pata-app/themes';

export const BusinessCarouselContainer = styled.section``;

export const BusinessTilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`;

export const TileContainer = styled.div`
  width: 100%;
`;

export const BusinessAdPlaceholder = styled.div`
  width: 100%;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const BusinessTilesSectionContainer = styled.div`
  display: flex;
  flex-direction: column;

  padding: 100px 0;
  margin: 0 ${({ theme }) => theme.core.sizing[2]}px;

  > div:last-of-type {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 300px;
    grid-auto-rows: max-content;
    gap: 20px;

    overflow-x: auto;
    scroll-snap-type: x mandatory;

    white-space: nowrap;

    a {
      height: 100%;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    > * {
      scroll-snap-align: start;
    }

    @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
      margin: 0;
    }
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    margin: 0;

    font-size: ${({ theme }) => theme.core.fontSizes.xxxl}px;

    > span {
      color: ${({ theme }) => theme.core.colors.primary.green.medium};
    }
  }

  p {
    font-size: ${({ theme }) => theme.core.fontSizes.l}px;
  }
`;
